import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { BP_ADMIN_STATUS_PROJECT } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const get_responsable_partner = (id) => {
    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.get(`${Config.API_BASE_URL}/bp/admin/project-change-responsable-partner/${id}`, config)
                .then(response => {
                    dispatch({
                        type: BP_ADMIN_STATUS_PROJECT,
                        payload: {
                            responsablesPartner: response.data,
                            // task: {
                            //     result: true
                            // }
                        }
                    });
                })
                .catch(error => {

                    throw (error);
                });

        }).catch(error => {

            // dispatch({ type: EXPIRED });
        });
    };
}

export default get_responsable_partner;
